import {
  FETCH_LOGIN_REQUEST,
  FETCH_LOGIN_SUCCESS,
  FETCH_LOGIN_FALUIRE,
  FETCH_CLEAR_ERROR_MESSAGE_FALUIRE,
} from './loginTypes'

const initialState = {
  loading: false,
  userInfo: null,
  error: null,
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LOGIN_REQUEST : return {
      ...state,
      loading: true,

    }
    case FETCH_CLEAR_ERROR_MESSAGE_FALUIRE : return {
      ...state,
      loading: false,
      error: null,

    }

    case FETCH_LOGIN_SUCCESS : return {
      ...state,
      userInfo: action.payload,
      error: null,
      loading: false,
    }

    case FETCH_LOGIN_FALUIRE : return {
      ...state,
      loading: false,
      userInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
